// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2KrFT","sticky":"Navbar_sticky__26XOD","logo":"Navbar_logo__1YM9H","navv":"Navbar_navv__1axOk"};